import http from '@/utils/http';
const base_path = '/v2/media/auth';

/**
 * 获取用户认证授权地址
 * @param {Object} params 请求参数
 * @returns {Promise<Object>}
 */
export const generateAuthUrlApi = (params) => {
  return http.get({
    url: `${base_path}/generateAuthUrl`,
    params,
  });
};

/**
 * 用户认证回调接口
 * @param {Object} data 请求参数
 * @returns {Promise<Object>}
 */
export const authCallbackApi = (data) => {
  return http.post({
    url: `${base_path}/authCallback`,
    data,
  });
};
